import React, { Suspense, useRef } from 'react'
import { Canvas } from '@react-three/fiber'
import { OrbitControls, Stage } from '@react-three/drei'
import { Model } from './Model'


export const Scene = (props) => {
  const ref = useRef()
  const style = {
    position: "relative",
    marginLeft: "auto",
    marginRight: "auto",
    width: 800,
    height: 600,
  };

  return (
    <div style={style}>
      <Canvas camera={{ fov: 50, zoom: 1 }}>
        <Suspense fallback={null}>
          <Stage controls={ref} preset="rembrandt" intensity={1}  environment="city">
            <Model getAnnotations={props.getAnnotations}/>
          </Stage>
        </Suspense>
        <OrbitControls ref={ref} />
      </Canvas>
    </div>
  )
}